export const SCENARIO_LIMITS = { MIN: 1, MAX: 100, DEFAULT: 50 } as const
export const TURNS_LIMITS = { MIN: 1, MAX: 200, DEFAULT: 25 } as const
export const RUN_BATCH_MAX = 100
export const AUTO_GENERATE_COUNT = 5
export const AUTO_GENERATE_SCENARIOS_ENABLED = false
